// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"21f6c29c","453":"12adda2a","455":"3b7abeb2","977":"b5ffbc04"}[chunkId] + ".chunk.js";
};